import { Card } from 'react-bootstrap'
import Loading from '../../components/Loading1'
import { useEffect } from 'react'
import { LOADING_STATE_LABEL } from '../../constants/prizes'

const PrizeReportGeneratingPage = ({ state, getStates }) => {
  useEffect(() => {
    const intervalStates = setInterval(() => {
      getStates()
    }, 1000 * 5)

    return () => clearInterval(intervalStates)
  }, [getStates])

  return (
    <Card.Body
      className="text-center d-flex align-items-center justify-content-center flex-column"
      style={{
        minHeight: '400px',
      }}
    >
      <Loading />
      <Card.Text className="mt-4">{LOADING_STATE_LABEL[state]}</Card.Text>
    </Card.Body>
  )
}

export default PrizeReportGeneratingPage
